var map = {
	"./pages/admin/assistants/assistants.module": [
		"./src/app/pages/admin/assistants/assistants.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~fea01c02",
		"common",
		"pages-admin-assistants-assistants-module"
	],
	"./pages/admin/doctors/doctors.module": [
		"./src/app/pages/admin/doctors/doctors.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~fea01c02",
		"common",
		"pages-admin-doctors-doctors-module"
	],
	"./pages/admin/doctors/view/view.module": [
		"./src/app/pages/admin/doctors/view/view.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-doctors-view-view-module~pages-admin-patients-view-view-module~pages-branch-head~056c7745",
		"common",
		"pages-admin-doctors-view-view-module"
	],
	"./pages/admin/expenses/expenses.module": [
		"./src/app/pages/admin/expenses/expenses.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~fea01c02",
		"common",
		"pages-admin-expenses-expenses-module"
	],
	"./pages/admin/home/home.module": [
		"./src/app/pages/admin/home/home.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-home-home-module~pages-branch-head-home-home-module",
		"common",
		"pages-admin-home-home-module"
	],
	"./pages/admin/patients/patients.module": [
		"./src/app/pages/admin/patients/patients.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~fea01c02",
		"common",
		"pages-admin-patients-patients-module"
	],
	"./pages/admin/patients/view/view.module": [
		"./src/app/pages/admin/patients/view/view.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-doctors-view-view-module~pages-admin-patients-view-view-module~pages-branch-head~056c7745",
		"common",
		"pages-admin-patients-view-view-module"
	],
	"./pages/admin/procedures/procedures.module": [
		"./src/app/pages/admin/procedures/procedures.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~fea01c02",
		"common",
		"pages-admin-procedures-procedures-module"
	],
	"./pages/admin/ranks/ranks.module": [
		"./src/app/pages/admin/ranks/ranks.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"common",
		"pages-admin-ranks-ranks-module"
	],
	"./pages/admin/reports/reports.module": [
		"./src/app/pages/admin/reports/reports.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-reports-reports-module~pages-admin-transactions-transactions-module~pages-branch~dd2439cf",
		"default~pages-admin-reports-reports-module~pages-admin-transactions-transactions-module~pages-branch~7f98130b",
		"common",
		"pages-admin-reports-reports-module"
	],
	"./pages/admin/secretaries/secretaries.module": [
		"./src/app/pages/admin/secretaries/secretaries.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~fea01c02",
		"common",
		"pages-admin-secretaries-secretaries-module"
	],
	"./pages/admin/settings/branch/branch.module": [
		"./src/app/pages/admin/settings/branch/branch.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"common",
		"pages-admin-settings-branch-branch-module"
	],
	"./pages/admin/settings/categories/categories.module": [
		"./src/app/pages/admin/settings/categories/categories.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"common",
		"pages-admin-settings-categories-categories-module"
	],
	"./pages/admin/settings/change-password/change-password.module": [
		"./src/app/pages/admin/settings/change-password/change-password.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"common",
		"pages-admin-settings-change-password-change-password-module"
	],
	"./pages/admin/settings/items/items.module": [
		"./src/app/pages/admin/settings/items/items.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"common",
		"pages-admin-settings-items-items-module"
	],
	"./pages/admin/settings/sizes/sizes.module": [
		"./src/app/pages/admin/settings/sizes/sizes.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"common",
		"pages-admin-settings-sizes-sizes-module"
	],
	"./pages/admin/settings/test/test.module": [
		"./src/app/pages/admin/settings/test/test.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"common",
		"pages-admin-settings-test-test-module"
	],
	"./pages/admin/transactions/transactions.module": [
		"./src/app/pages/admin/transactions/transactions.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~fea01c02",
		"default~pages-admin-reports-reports-module~pages-admin-transactions-transactions-module~pages-branch~dd2439cf",
		"default~pages-admin-reports-reports-module~pages-admin-transactions-transactions-module~pages-branch~7f98130b",
		"common",
		"pages-admin-transactions-transactions-module"
	],
	"./pages/admin/users/list/list.module": [
		"./src/app/pages/admin/users/list/list.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"common",
		"pages-admin-users-list-list-module"
	],
	"./pages/admin/users/list/view-user-log/view-user-log.module": [
		"./src/app/pages/admin/users/list/view-user-log/view-user-log.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"common",
		"pages-admin-users-list-view-user-log-view-user-log-module"
	],
	"./pages/branch-head/expenses/expenses.module": [
		"./src/app/pages/branch-head/expenses/expenses.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~fea01c02",
		"common",
		"pages-branch-head-expenses-expenses-module"
	],
	"./pages/branch-head/home/home.module": [
		"./src/app/pages/branch-head/home/home.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-home-home-module~pages-branch-head-home-home-module",
		"common",
		"pages-branch-head-home-home-module"
	],
	"./pages/branch-head/patients/patients.module": [
		"./src/app/pages/branch-head/patients/patients.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~fea01c02",
		"common",
		"pages-branch-head-patients-patients-module"
	],
	"./pages/branch-head/patients/view/view.module": [
		"./src/app/pages/branch-head/patients/view/view.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-doctors-view-view-module~pages-admin-patients-view-view-module~pages-branch-head~056c7745",
		"common",
		"pages-branch-head-patients-view-view-module"
	],
	"./pages/branch-head/reports/reports.module": [
		"./src/app/pages/branch-head/reports/reports.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-reports-reports-module~pages-admin-transactions-transactions-module~pages-branch~dd2439cf",
		"common",
		"pages-branch-head-reports-reports-module"
	],
	"./pages/branch-head/settings/change-password/change-password.module": [
		"./src/app/pages/branch-head/settings/change-password/change-password.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"common",
		"pages-branch-head-settings-change-password-change-password-module"
	],
	"./pages/branch-head/transactions/transactions.module": [
		"./src/app/pages/branch-head/transactions/transactions.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~210a3ded",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~cf2a6340",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~87512a01",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~fea01c02",
		"default~pages-admin-reports-reports-module~pages-admin-transactions-transactions-module~pages-branch~dd2439cf",
		"default~pages-admin-reports-reports-module~pages-admin-transactions-transactions-module~pages-branch~7f98130b",
		"common",
		"pages-branch-head-transactions-transactions-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~fd9ce1c3",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-doct~bad8226f",
		"default~pages-admin-assistants-assistants-module~pages-admin-doctors-doctors-module~pages-admin-expe~851ece00",
		"common",
		"pages-login-login-module"
	],
	"./pages/registration/registration.module": [
		"./src/app/pages/registration/registration.module.ts",
		"pages-registration-registration-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;